<template>
    <div>
        <PageHeader title="จัดการคะแนนสอบ" />
        <b-container>
            <div class="py-2"></div>
            <div class="no-data" v-if="!hasExamData">
                ไม่พบข้อสอบ
            </div>
            <div class="py-3">
                <!-- search course -->
                <div class="inner bg-container">
                    <div style="display: flex">
                        <h6 style="margin-right: 150px; display: inline">
                            <strong class="pre-formatted">กรุณาเลือกหลักสูตรและข้อสอบที่ต้องการกรอกคะแนน </strong>
                        </h6>
                    </div>
                    <div class="mt-5">
                        <h6 class="mb-3"><strong>ชื่อคอร์ส</strong></h6>
                        <v-select
                            :options="courseData"
                            v-model="selectedCourse"
                            placeholder="พิมพ์ชื่อคอร์สที่ต้องการค้นหา..."
                            :disabled="!courseData.length"
                            :clearable="false"
                            :loading="isCourseLoading"
                        />
                    </div>

                    <!-- search exam -->
                    <div class="mt-5">
                        <h6 class="mb-3"><strong>เลือกข้อสอบ</strong></h6>
                        <v-select
                            :options="examOption"
                            v-model="selectedExam"
                            placeholder="พิมพ์ชื่อข้อสอบที่ต้องการค้นหา..."
                            :disabled="!examOption.length"
                            :clearable="false"
                            :loading="isExamLoading"
                        />
                    </div>

                    <!-- exam score -->
                    <div class="mt-5">
                        <h6 class="mb-3"><strong>กำหนดคะแนนเต็ม</strong></h6>
                        <div class="d-flex">
                            <div class="input-group w-25">
                                <input 
                                    type="number" 
                                    placeholder="คะแนนเต็ม" 
                                    class="form-control" 
                                    v-model="examMaxScore" 
                                    min="0"
                                    max="1000"
                                    @blur="limitScore"
                                    :disabled="examMaxScoreDisable || !isEditAble"
                                >
                                <div class="input-group-prepend">
                                    <span class="input-group-text" style="border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                                        คะแนน
                                    </span>
                                </div>
                            </div>
                            <b-button @click="isConfirmStatus = true" :disabled="examMaxScoreDisable || !examMaxScore" variant="primary" class="ml-5" style="font-size: small;">ยืนยันคะแนนเต็ม</b-button>
                        </div>
                        <span class="mt-2" style="color: gray; font-size: x-small;">
                            กำหนดได้ครั้งแรกเท่านั้น
                        </span>
                    </div>
                    <div class="mt-5">
                        <div class="mb-3"><strong>รายละเอียดการเข้าเรียน</strong> ผู้เรียนในปัจจุบัน {{ memberEnroll.length }} คน</div>
                    </div>

                    <div v-if="!isEditAble">
                        <p class="online-exam">ไม่สามารถแก้ไขข้อมูลในข้อสอบออนไลน์ได้</p>
                    </div>
                    <template v-if="isShowTable">
                        <div v-if="memberEnroll.length > 0">
                            <EditExamAttendance 
                                :courseId="courseId"
                                :memberEnroll="memberEnroll"
                                :maxScore="examMaxScore"
                                :isEditAble="isEditAble"
                            />
                        </div>
                    </template>
                </div>
                
            </div>
        </b-container>
        <WarningActionModal
            :show="isConfirmStatus"
            :title="'ยืนยันกำหนดคะแนนเต็มหรือไม่?'"
            :detail="
                `คะแนนเต็มกำหนดได้เพียงครั้งแรกเท่านั้น <br> ต้องการกำหนดคะแนนเต็ม <strong>${examMaxScore}</strong> คะแนน หรือไม่`
            "
            :actionName="'ยืนยัน'"
            :successTitle="'ยืนยันสถานะการเข้าเรียนสำเร็จ'"
            @canceled="isConfirmStatus = false"
            @action="setQuizOfflineMaxScore()"
            @onSuccess="isShowConfirmStatusModal = false"
        />
    </div>
</template>

<script>
import PageHeader from "@/components/layouts/PageHeader.vue";
import EditExamAttendance from "./ExamAttendanceTable.vue";
import api from "@/services/api.js";
import vSelect from "vue-select";
import WarningActionModal from "../attendance/modal/WarningActionAttendanceModal.vue";

export default {
    name: "ExamAttendance",
    components: {
        PageHeader,
        EditExamAttendance,
        vSelect,
        WarningActionModal,
    },
    data() {
        return {
            comId: this.$store.state.Company.companyInfo.id,
            courseData: [],
            hasCourseData: false,
            selectedCourse: null,
            courseId: null,
            isDisplayNoData: false,

            examData: [],
            examOption: [],
            hasExamData: true,
            selectedExam: null,

            memberEnroll: [],

            examMaxScore: null,
            lecId: null,
            qlecId: null,
            examMaxScoreDisable: true,

            isShowTable: false,

            isEditAble: true,
            isConfirmStatus: false,
            isShowConfirmStatusModal: false,

            isCourseLoading: false,
            isExamLoading: false,
        }
    },
    async created() {
        this.isCourseLoading = true;
        await api.get(`/v1/companies/${this.comId}/courses?excepts=numberOfStudent,numberOfActiveStudent,coursePrice,tfac,tfacQuarter&sort_by=name&sort_order=asc&type=ALL`).then(({ data }) => {
            this.courseData = data.data.map(course => ({ label: course.courseName, value: course.courseId }));
            this.hasCourseData = !!this.courseData.length;
        });
        this.isCourseLoading = false;
    },
    watch: {
        selectedCourse(newCourse) {
            this.courseId = newCourse.value;
            this.examMaxScoreDisable = true;
            this.lecId = null
            this.isEditAble = true
            this.fetchExamData();
        },
        selectedExam(newExam) {
            this.examMaxScore = null;
            this.isEditAble = true;
            this.lecId = null;
            this.memberEnroll = [];

            if (!newExam) return;

            this.qlecId = newExam.value;

            const exam = this.examData.find(obj => obj.quiz_id === this.qlecId);
            this.examMaxScore = exam.quiz_offlineMaxScore;
            this.isEditAble = ( exam?.quiz_totalQuestion > 0 ) ? false : true
            this.lecId = exam.lec_id;

            if (this.examMaxScore == null ) {
                this.examMaxScoreDisable = false;
                this.isShowTable = false
            } else {
                this.examMaxScoreDisable = true;
                this.isShowTable = true
            }

            this.fetchMemberEnroll();
        },
    },
    methods: {
        async fetchExamData() {
            this.isExamLoading = true;
            await api.get(`/v1/courses/${this.courseId}/exam`).then(({ data }) => {
                this.examData = data;
                this.examOption = data.map(exam => ({ label: exam.lec_name, value: exam.quiz_id }));
                this.hasExamData = !!this.examOption.length;
                this.memberEnroll = [];
                this.selectedExam = null;
            });
            this.isExamLoading = false;
        },
        async fetchMemberEnroll() {
            await api.get(`/v1/exam-attendance/${this.lecId}`).then(({ data }) => {
                this.memberEnroll = data;
            });
        },
        async setQuizOfflineMaxScore() {
            await api.post(`/v1/exam/${this.qlecId}/offline-max-score`, {
                maxScore: this.examMaxScore,
            });
            const exam = this.examData.find(obj => obj.quiz_id === this.qlecId);
            exam.quiz_offlineMaxScore = this.examMaxScore
            this.examMaxScoreDisable = true;
            this.isShowTable = true
            this.isConfirmStatus = false
        },
        openModal() {
            this.isConfirmStatus = true
        },
        limitScore() {
            if (this.examMaxScore < 1) this.examMaxScore = 1
            if (this.examMaxScore > 1000) this.examMaxScore = 1000
        }
    }
}
</script>
<style lang="css">
.online-exam {
    color: orange;
    width: 100%;
    padding: 0.75rem 1.25rem;
    background-color: #f9e7d5;
    border: #f9e7d5 1px solid;
    border-radius: 0.25rem;
}
</style>